import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';

import { HttpClientService } from './http-client.service';
import type { EmailPreviewClient, EmailPreviewRequest, EmailPreviewResponse } from '../tokens/email-preview-client.token';
import { EMAIL_PREVIEW } from '../../shared/constants/api-routes.constants';

@Injectable({ providedIn: 'root' })
export class EmailPreviewService implements EmailPreviewClient {
  private readonly http = inject(HttpClientService);

  getPreview(request: EmailPreviewRequest): Observable<EmailPreviewResponse> {
    const { templateKey, model } = request;
    return this.http.post<EmailPreviewResponse>(EMAIL_PREVIEW.PREVIEW(), { templateKey, model });
  }
}
